import { result } from "lodash";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { BusinessDaysClient } from "../../../../../../Wrap/Api/Common/BusinessDays";
import { IsBusinessDayClient } from "../../../../../../Wrap/Api/Common/IsBusinessDay";

export class BusinessDaysAction {
    public static GetBusinessDays(BaseDate: Date, Future: boolean, NumberOfDays: number, Max: boolean, callback) {
        const client = new BusinessDaysClient();
        client.get(NumberOfDays, Future ? 1 : 2, JsonDateParser.toJsonDateNoOffset(BaseDate), Max).onSuccess((d) => {
            callback(d);
        });
    }

    public static IsBusinessDay(date: Date, callback: (val: boolean) => void) {
        const client = new IsBusinessDayClient();
        client.get(JsonDateParser.toJsonDate(date)).onSuccess((result: boolean) => callback(result));
    }
}
